import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// Components
import { Search, Button } from 'carbon-components-react';
import StudyListGrid from './StudyListGrid';

const StudyListContent = ({
  studyList,
  setOpenNewStudyModal,
  setTriggerExport,
  triggerExport,
  onDeleteClicked,
  // onSyncClicked,
  onExportClicked,
  reportStatus,
  refresh,
  setRefresh,
}) => {
  const [search, setSearch] = useState("");
  const [searchGrid, setSearchGrid] = useState("");
  const [sort, setSort] = useState("")
  const onlyAttachment = localStorage.getItem('only_attachment')

  //Waits for a second after last user input on search
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search);
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search]);

  return (
    <Container>
      <ContentHeader>
        <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => {
                  setSearch(e.target.value)

                }}
                placeHolderText="Search using any data value"
              />
            </div>
            <ButtonPadding>
              <Button
                kind="secondary"
                onClick={onExportClicked}
                style={addStudyBtnStyle}
                disabled={reportStatus === 'polling'}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              <Button
                  kind="primary"
                  onClick={() => setOpenNewStudyModal(true)}
                  style={addStudyBtnStyle}
                  disabled={onlyAttachment === "true"}
                >Add New Study</Button>
            </ButtonPadding>
          </ActionBar>
      </ContentHeader>
    
      <StudyContent>
          <StudyListGrid
            search={searchGrid}
            studyList={studyList} 
            setTriggerExport={setTriggerExport}
            triggerExport={triggerExport}
            onDeleteClicked={onDeleteClicked}
            refresh={refresh}
            setRefresh={setRefresh}
            sort={sort}
            setSort={setSort}
            />
      </StudyContent>
    </Container>
  );
};

export default StudyListContent;


const StudyContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonPadding = styled.div`
  display: flex;
  gap: 8px;
  background-color: #fff;
`

const addStudyBtnStyle = {
  padding: "11px 18px",
  height: "auto",
  minHeight: "unset",
  borderRadius: "10px",
  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  fontWeight: 700,
  fontSize: "13.5px",
};

const Container = styled.div`
  display: flex;
  flex-flow: column;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
  padding: 22px 24px;
  flex: 1 1 auto;
  height: 100%;
  overflow: hidden;
`

const ContentHeader = styled.div`
  flex: 0 1 auto;
`